<!-- @format -->

<ng-container *transloco="let t">
  <sis-expandable
    [title]="customModuleAttainment() | attainmentName | async | localizedString"
    [variant]="'naked-dotted'"
    [contentPadding]="'none'"
    [closed]="false"
    [level]="headingLevel()"
    [size]="getHeadingSize()"
    [disabled]="headingLevel() !== 3"
    [hideIcon]="headingLevel() !== 3">
    <ng-template sisExpandableCustomTitle>
      <sis-plan-structure-module-state-badges [stateObject]="customModuleAttainmentStateObject()"> </sis-plan-structure-module-state-badges>
      <div class="expandable__title__sub-title expandable__title__sub-title__size__md">
        <div class="d-flex flex-column flex-sm-row align-items-center sis-plan-structure-custom-module-attainment__font-weight-regular">
          <div class="me-auto me-sm-0">
            @if (customModuleAttainment()?.code) {
              <ng-container>
                {{ customModuleAttainment().code }}
              </ng-container>
            }
          </div>
        </div>
      </div>
    </ng-template>
    @if (customModuleAttainment()) {
      <ng-template sisExpandableContent>
        <div
          class="d-flex flex-wrap"
          [class.study-background]="useBackgroundColor()"
          [class.study-background-spacing]="useBackgroundColor()">
          <div class="study-credit-info">
            <div class="d-flex flex-wrap">
              <sis-description-list-compact [fillByColumn]="false">
                <dl>
                  <ng-template #compactListItem>
                    <dt class="label colon">{{ t("SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS") }}</dt>
                    @if (customModuleAttainment()?.credits | decimalNumber) {
                      <dd class="value">{{ (customModuleAttainment()?.credits | decimalNumber) + " " + t("CREDITS") }}</dd>
                    } @else {
                      <dd class="value">{{ "-" }}</dd>
                    }
                  </ng-template>
                </dl>
              </sis-description-list-compact>
            </div>
            <div class="d-flex flex-wrap">
              <sis-plan-structure-module-selection-state
                [stateObject]="customModuleAttainmentStateObject()"
                class="sis-mr-xs"></sis-plan-structure-module-selection-state>
              <sis-description-list-compact [fillByColumn]="false">
                <dl>
                  <ng-template #compactListItem>
                    <dt class="label colon">{{ t("SIS_COMPONENTS.PLAN.LABEL.ATTAINED") }}</dt>
                    @if (customModuleAttainment()?.credits; as attainedCredits) {
                      <dd class="value">
                        {{ (attainedCredits | decimalNumber) + " " + t("CREDITS") }}
                      </dd>
                    } @else {
                      <dd class="value">{{ "-" }}</dd>
                    }
                  </ng-template>
                </dl>
              </sis-description-list-compact>
            </div>
          </div>
        </div>
        <sis-plan-structure-attainment-node-structure
          [attainmentNodes]="customModuleAttainment().nodes"
          [headingLevel]="headingLevel() + 1">
        </sis-plan-structure-attainment-node-structure>
      </ng-template>
    }
  </sis-expandable>
</ng-container>
